import { connect } from "react-redux"
import { withRouter } from "react-router"
import { compose } from "redux"
import SummaryButton from "./SummaryButton"
import { setSummaryIsOpen, setDataTableIsOpen } from "store/actions/reduxActions"

const mapStateToProps = (state, props) => ({
	summaryIsOpen: state.summaryIsOpen,
	dataTableIsOpen: state.dataTableIsOpen,
})

const mapDispatchToProps = (dispatch) => ({
	setSummaryIsOpen: (isOpen) => dispatch(setSummaryIsOpen(isOpen)),
	setDataTableIsOpen: (isOpen) => dispatch(setDataTableIsOpen(isOpen)),
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(SummaryButton)
